import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '~env';
import { OidcClientAuthService } from './oidc-client-auth.service';

@Injectable()
export class OidcInterceptorService implements HttpInterceptor {
  static OidcInterceptorService: any;
  constructor(private oidcClient: OidcClientAuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const notSecureUri = ['/assets', environment.documentStorageUrl];

    if (notSecureUri.some(uri => req.url.startsWith(`${uri}`))) {
      return next.handle(req);
    }

    return from(this.oidcClient.getAccessToken()).pipe(
      switchMap(token => {
        if (token) {
          const headers = req.headers.set('Authorization', `Bearer ${token}`);
          const authReq = req.clone({ headers });
          return next.handle(authReq);
        }
        return next.handle(req);
      }),
    );
  }
}
